/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "973b7c91c818dda94718c568f34b6978888fd94c";
